<mat-form-field class="navn">
  <mat-label>{{ 'Mappenavn'|translate }}</mat-label>
  <input matInput [formControl]="skjema().controls.navn" data-testid="navn">
  @if (skjema().controls.navn.hasError('maxlength')) {
    <mat-error data-testid="maxlength">
      {{ skjema().controls.navn.errors | standardvalideringsfeil:'maxlength' }}
    </mat-error>
  }
</mat-form-field>
<mat-form-field>
  <mat-label>{{ 'Beskrivelse'|translate }}</mat-label>
  <riktekst-redigering [skjemakontroll]="skjema().controls.beskrivelse" [gruppeId]="gruppeId()" data-testid="beskrivelse"/>
</mat-form-field>
